// extracted by mini-css-extract-plugin
export default {"element":"anime_element__eGjBK"};